export default (timeLeft) => {
    return `<small>${timeLeft.hours?timeLeft.hours:'00'} : </small>
        <small>${timeLeft.minutes?((timeLeft.minutes<10)?'0'+timeLeft.minutes:timeLeft.minutes):'00'} : </small>
        <small>${timeLeft.seconds?(Math.round(timeLeft.seconds)<10?'0'+Math.round(timeLeft.seconds):Math.round(timeLeft.seconds)):'00'}</small>`
}